<script>
export default {
  name: 'UlFormGender',
  props: {
    value: {
      type: Object,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    values: new Map([[true, {
      value: 0,
      label: 'Взрослый',
    }], [false, {
      value: 1,
      label: 'Женский',
    }]]),
  }),
  computed: {
    val() {
      return this.value?.value === 0;
    },
  },
  methods: {
    input(e) {
      this.$emit('input', this.values.get(e.target.checked));
    },
    change(e) {
      this.$emit('change', this.values.get(e.target.checked));
    },
  },
};
</script>
<template>
  <div
    class="ul-form-gender"
    :class="{'ul-form-gender--disabled': disabled}"
  >
    <input
      type="checkbox"
      :checked="val"
      :disabled="disabled"
      @input="input"
      @change="change"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    >
    <div class="ul-form-gender__icon">
      <i class="ul-icon-gender-true" v-if="val"></i>
      <i class="ul-icon-gender-false" v-if="!val"></i>
    </div>
  </div>
</template>
<style lang="scss">
  .ul-form-gender {
    line-height: 28px;
    display: flex !important;
    align-items: center;
    position: relative;
    font-size: 22px;
    justify-content: center;

    &__icon {
      width: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 28px;
    }

    &--disabled {
      cursor: default;
    }

    input {
      margin: 0;
      width: 28px;
      height: 28px;
      display: block;
      opacity: 0;
      position: absolute;
      cursor: pointer;
    }

    .ul-icon-gender-true {
      color: #4A90E2;
    }

    .ul-icon-gender-false {
      color: #F7005F;
    }
  }
</style>
